import { Button } from '@mantine/core';
import { Plus } from 'lucide-react';
import type { FC } from 'react';
import styles from './library-card-action.module.css';

interface LibraryCardMenuProps {
	onAdd: () => void;
}

const LibraryCardAction: FC<LibraryCardMenuProps> = ({ onAdd }) => {
	return (
		<Button
			className={styles.plusCta}
			onClick={onAdd}
		>
			<Plus color="white" />
		</Button>
	);
};

export default LibraryCardAction;
